import React from 'react';
import { Icon } from 'semantic-ui-react';
import './BoxHeader.css';

/**
 * Component BoxHeader
 * @param string props.icon
 * @param Object jsx props.children
 */
const BoxHeader = (props) => {
  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <div className="mb-4">
      <h2 className="title-mb">
        {(props.icon) ? <Icon name={props.icon} /> : null}
        {props.children}
      </h2>
    </div>
  )
}

export default BoxHeader;